var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18637",
    "data-name": "Group 18637",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.658,
    height: 15.428,
    viewBox: "0 0 18.658 15.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .walletWhite{fill:#fff;fill-rule:evenodd}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18169",
    "data-name": "Group 18169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M320.177 365.971a1.365 1.365 0 1 1 1.365 1.365 1.366 1.366 0 0 1-1.365-1.365z",
    transform: "translate(-307.961 -358.257)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    className: "walletWhite",
    d: "M323.466 360.5a4.287 4.287 0 0 0-3.5-2.583l-.593-.063a40.413 40.413 0 0 0-9.009.062l-.393.047a3.348 3.348 0 0 0-2.924 2.883 34.024 34.024 0 0 0 0 9 3.349 3.349 0 0 0 2.924 2.883l.393.047a40.461 40.461 0 0 0 9.009.062l.593-.063a4.286 4.286 0 0 0 3.5-2.583 2.519 2.519 0 0 0 1.785-2.114 23.454 23.454 0 0 0 0-5.464 2.521 2.521 0 0 0-1.785-2.114zm-4.231-1.288a39 39 0 0 0-8.7.06l-.393.046a1.984 1.984 0 0 0-1.732 1.709 32.6 32.6 0 0 0 0 8.639 1.985 1.985 0 0 0 1.732 1.709l.393.046a39 39 0 0 0 8.7.06l.593-.063a2.914 2.914 0 0 0 1.934-1.029 24.4 24.4 0 0 1-4.12-.107 2.521 2.521 0 0 1-2.225-2.2 23.454 23.454 0 0 1 0-5.464 2.522 2.522 0 0 1 2.225-2.2 24.6 24.6 0 0 1 4.12-.107 2.922 2.922 0 0 0-1.934-1.029zm3.172 2.508v.011l.005.035.18-.028.28.029a1.159 1.159 0 0 1 1.022 1.006 22.216 22.216 0 0 1 0 5.147 1.159 1.159 0 0 1-1.022 1.006l-.28.029-.18-.028-.005.035v.011a23.115 23.115 0 0 1-4.613-.047 1.159 1.159 0 0 1-1.022-1.006 22.23 22.23 0 0 1 0-5.147 1.159 1.159 0 0 1 1.022-1.006 23.112 23.112 0 0 1 4.613-.05z",
    transform: "translate(-306.752 -357.629)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    className: "walletWhite",
    d: "M326.092 362.871a2.515 2.515 0 0 0-1.656-2.066 15.646 15.646 0 0 0-1.834-.246 24.6 24.6 0 0 0-4.12.107 2.523 2.523 0 0 0-2.225 2.2 23.454 23.454 0 0 0 0 5.465 2.523 2.523 0 0 0 2.225 2.2 24.5 24.5 0 0 0 4.12.106 15.6 15.6 0 0 0 1.7-.2 2.519 2.519 0 0 0 1.785-2.114 23.45 23.45 0 0 0 .005-5.452zm-1.356 5.306a1.158 1.158 0 0 1-1.021 1.005l-.28.029-.187.018v-.011.011a23.115 23.115 0 0 1-4.613-.047 1.159 1.159 0 0 1-1.022-1.005 22.137 22.137 0 0 1 0-5.148 1.159 1.159 0 0 1 1.022-1.005 23.106 23.106 0 0 1 4.613-.047v.011-.011l.187.018.28.029a1.158 1.158 0 0 1 1.021 1.005 22.137 22.137 0 0 1 .001 5.148z",
    transform: "translate(-307.594 -357.889)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWhite);
export default __webpack_public_path__ + "static/media/wallet-white.f5b037195277d588fd3eaa0c4dd60cbc.svg";
export { ForwardRef as ReactComponent };